import { render, staticRenderFns } from "./zeroActivityDetails.vue?vue&type=template&id=579795f3&scoped=true&"
import script from "./zeroActivityDetails.vue?vue&type=script&lang=js&"
export * from "./zeroActivityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579795f3",
  null
  
)

export default component.exports